import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./SectionLabel";

const learns = [
  "Foods you eat",
  "Portions",
  "Eating patterns",
  "Weight changes",
  "Workout behaviour",
  "Consistency",
];

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const Personalization = () => (
  <section className="py-24 md:py-32 lg:py-40" data-testid="personalization-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <SectionLabel number={3} title="Personalisation" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <motion.h2
            {...fadeUp}
            className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight font-medium text-[#171717]"
          >
            The more you use it, the more it understands you.
          </motion.h2>

          <motion.div {...fadeUp} transition={{ ...fadeUp.transition, delay: 0.12 }} className="mt-8 flex flex-wrap gap-2.5">
            {learns.map((l) => (
              <span
                key={l}
                className="text-sm text-[#171717]/60 border border-[#171717]/10 rounded-full px-4 py-1.5"
              >
                {l}
              </span>
            ))}
          </motion.div>
        </div>

        <div className="lg:col-span-6 lg:col-start-7 flex flex-col gap-4">
          <motion.div
            {...fadeUp}
            className="rounded-2xl border border-[#171717]/8 bg-white/50 p-7 md:p-8"
          >
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#171717]/40 mb-5">
              Generic tracker
            </p>
            <div className="flex items-center gap-3 text-lg text-[#171717]/55 flex-wrap">
              <span>Data goes in</span>
              <ArrowRight size={16} className="text-[#171717]/25" />
              <span>Data sits there</span>
            </div>
          </motion.div>

          <motion.div
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.15 }}
            className="rounded-2xl p-7 md:p-8 bg-[#171717] text-[#F8F7F3]"
          >
            <p className="text-xs font-semibold tracking-[0.15em] uppercase text-[#F8F7F3]/40 mb-5">
              Quantify
            </p>
            <div className="flex items-center gap-3 text-lg md:text-xl font-medium flex-wrap">
              <span>Data goes in</span>
              <ArrowRight size={18} className="text-[#F8F7F3]/30" />
              <span>Patterns emerge</span>
              <ArrowRight size={18} className="text-[#F8F7F3]/30" />
              <span className="text-[#B8D99A]">Understanding compounds</span>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
